import React from "react"
import styles from "./index.module.scss"
import { useRouter } from "next/router"
import { applyLocaleToUrl } from "@/utils/formatters"

const FeatureCardGrid = ({ featureCardGridData = {} }) => {
  const { locale } = useRouter()
  const { cards = [] } = featureCardGridData
  return (
    <div className={styles.container}>
      {cards?.map(card => {
        const { fields: { title, description, image, cta } = {} } = card ?? {}
        const { fields: { imageUrl, src, altText, assets } = {} } = image ?? {}
        const { fields: { file } = {} } = assets?.[0] ?? {}
        const { url: assetUrl } = file ?? {}
        const { fields: { url: ctaUrl, label: ctaLabel } = {} } = cta ?? {}

        return (
          <div key={title} className={styles.card}>
            {(imageUrl || assetUrl) && (
              <a href={src} className={styles.imageWrapper}>
                <img src={imageUrl || assetUrl} alt={altText} />
              </a>
            )}
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
            <a href={applyLocaleToUrl(ctaUrl, locale)} className={styles.cta}>
              {ctaLabel}
            </a>
          </div>
        )
      })}
    </div>
  )
}

export default FeatureCardGrid
